import styled from 'styled-components';
import { black16 } from '../../styles/colors';
import { margin } from '../../styles/system';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSparator = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledSparator",
  componentId: "sc-1neye8n-0"
})(["width:100%;height:1px;background-color:", ";", ""], black16, margin.withDefaults({
  my: 2
}));

function MenuSeparator(props) {
  return /*#__PURE__*/_jsx(StyledSparator, Object.assign({
    role: "separator"
  }, props));
}

export { MenuSeparator };